import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'

@Component({
  selector: 'app-tokeet-select',
  templateUrl: './tokeet-select.component.html',
  styleUrls: ['./tokeet-select.component.scss'],
})
export class TokeetSelectComponent implements OnInit {
  @Input() items: any[]
  @Input() placeholder: string
  @Input() multiple = true
  @Input() hasBlank = false
  @Input() ctrl: FormControl
  @Input() bindLabel?: string
  @Input() bindValue?: string

  constructor() {}

  ngOnInit() {}

  onFilter(term: string) {}
}
